module.exports = __webpack_public_path__ + "img/1557614072769355777.52d4c85e.png";